import useFilePathContext from "utils/files/useFilePathContext"

export default function useFilePathCallback() {
  return useFilePathContext()
}
